import React from "react";
import { writeFile, utils } from "xlsx-js-style";

const DownloadForm22Excel = ({ data }) => {
  const generateExcel = () => {
    if (!data || data.length === 0) return;

    const headers = [
      "S. No.",
      "Emp Code",
      "Emp Name",
      "Father's Name",
      "Designation",
      "DOJ",
      "Days in Month",
      ...Array.from({ length: 31 }, (_, i) => `${i + 1}`), // 1 to 31 days
      "Present",
      "Absent",
      "WO",
      "Payable Days",
      "Wages",
      "Remarks",
    ];

    const excelData = [headers];

    data.forEach((item, index) => {
      const row = [
        index + 1,
        item.empCode || "-",
        item.empName || "-",
        item.fatherName || "-",
        item.designation || "-",
        item.doj || "-",
        item.daysInMonth || "-",
        ...Array.from({ length: 31 }, (_, i) => item.attendance?.[i + 1] || "-"),
        item.totalPresent || 0,
        item.absent || 0,
        item.wo || 0,
        item.payableDays || 0,
        item.wages || 0,
        item.remarks || "-",
      ];
      excelData.push(row);
    });

    const worksheet = utils.aoa_to_sheet(excelData);
    const workbook = utils.book_new();
    utils.book_append_sheet(workbook, worksheet, "Form 22");

    writeFile(workbook, "Form_22.xlsx");
  };

  return <button onClick={generateExcel}>Download Form 22 Excel</button>;
};

export default DownloadForm22Excel;
